import { render, staticRenderFns } from "./TodaysAppointment.vue?vue&type=template&id=5d81f9b2"
import script from "./TodaysAppointment.vue?vue&type=script&lang=js"
export * from "./TodaysAppointment.vue?vue&type=script&lang=js"
import style0 from "./TodaysAppointment.vue?vue&type=style&index=0&id=5d81f9b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports